module.exports = __webpack_public_path__ + "static/media/Dconf16.cfa0c651.png";